import React, { useEffect, useState } from 'react';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { reduxForm, formValueSelector } from 'redux-form'
import Link from '../Link/Link';
import LottieImage from '../Common/LottieImage/LottieImage';
import messages from '../../locale/messages';
import history from '../../history';
import { closeHeaderModal } from '../../actions/siteadmin/modalActions';
import { getBooking } from '../../actions/booking/getBooking';
import { cancelBookingAction } from '../../actions/booking/cancelBookingAction';
import noServiceProviderIcon from '/public/dashboard/noServiceProviderIcon.svg';
import animationData from '../../../public/lottie/nearestProviderAnimationData.json'
import bt from '../commonStyle.css';
import s from './NearestProviderForm.css';

function NearestProviderForm({ socket }) {

    const [declined, setDeclined] = useState(false)
    const bookingError = useSelector(state => state?.booking?.data?.error)
    const isPreffered = useSelector(state => state?.adminModalStatus?.isPreffered)
    const id = useSelector(state => formValueSelector('ConfirmBookingBanner')(state, 'bookingId'))
    const dispatch = useDispatch()
    const { formatMessage } = useIntl()

    useEffect(() => {
        if (socket && id) {
            socket.on(`bookingStatusUpdated-${id}`, (value) => {
                let socketValue = JSON.parse(value);
                const bookingStatus = socketValue?.data?.data?.bookingStatus;
                if (bookingStatus === "declined") {
                    setDeclined(true)
                } else if (bookingStatus === "approved") {
                    handleBookingApproved();
                }
            });
        }
    }, [socket, id])

    const handleBookingApproved = async () => {
        await dispatch(getBooking(id));
        history.push(`/tracking/${id}`);
        dispatch(closeHeaderModal('nearestProviderForm'));
    };

    if (declined) {
        return (
            <div>
                <div className={s.nearestNoServiceImgContainer}>
                    <img src={noServiceProviderIcon} alt="No Service Provider" />
                </div>
                {isPreffered && <div className={cx(bt.fontWeight700, bt.commonSize20, bt.primaryColor, bt.textAlignCenter, bt.space1)}>{formatMessage(messages.requestDeclinedLabel)}</div>}
                {isPreffered ? <div className={cx(bt.commonSize14,bt.textAlignCenter)}><FormattedMessage {...messages.preferredProviderDeclineLabel} /> </div> : <div className={cx(bt.fontWeight700, bt.commonSize20, bt.primaryColor, bt.textAlignCenter)}><FormattedMessage {...messages.noServiceProvider} /></div>}
            </div>
        );
    }

    return (
        <>
            {
                (bookingError === 'Sorry, no service providers available for your order. Please try again.') ?
                    <div>
                        <div className={s.nearestNoServiceImgContainer}>
                            <img src={noServiceProviderIcon} alt="No Service Provider" />
                        </div>
                        <div className={cx(bt.fontWeight700, bt.commonSize20, bt.primaryColor, bt.textAlignCenter)}>
                            {isPreffered ? <FormattedMessage {...messages.currencyNoProvidersAvailable} /> : <FormattedMessage {...messages.noServiceProvider} />}
                        </div>
                    </div> :
                    <div>
                        <div className={s.nearestProviderImgContainer}>
                            <LottieImage animationData={animationData} bookingError={bookingError} />
                        </div>
                        <div className={cx(bt.fontWeight700, bt.commonSize20, bt.primaryColor, bt.textAlignCenter, bt.space3)}>
                            {isPreffered ? <FormattedMessage {...messages.connectPreferredProviderText} /> : <FormattedMessage {...messages.connectProviderText} />}
                        </div>
                        <div className={s.nearestProviderLinkContainer}>
                            <Link to="#" onClick={() => dispatch(cancelBookingAction({ bookingId: id }))} className={bt.viewAllLink}>
                                <FormattedMessage {...messages.cancelBooking} />
                            </Link>
                        </div>
                    </div>
            }
        </>
    )
}
NearestProviderForm = reduxForm({
    form: 'NearestProviderForm',
})(NearestProviderForm);


export default withStyles(bt, s)(NearestProviderForm);
